import { useCallback, useState } from 'react';

export const CookieUtils = {
  setCookie(name: string, value: string, days?: number, domain?: string, secure?: boolean) {
    let expires = '';
    const secureTag = secure ? '; secure' : '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString() + (domain ? `; domain=${domain}` : '');
    }
    const pathTag = '; path=/';
    document.cookie = `${name}=${value || ''}${expires}${pathTag}${secureTag}`;
  },

  getCookie(name: string) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  },

  eraseCookie(name: string) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  },
};

/**
 * Hook to manage a state that is persisted in a cookie
 * @param name - name of the cookie
 * @param defaultValue - default value of the state
 */
export const useCookieState = (
  name: string,
  defaultValue?: string,
): [string | undefined, (value?: string, days?: number, domain?: string) => void] => {
  const [state, setState] = useState<string | undefined>(CookieUtils.getCookie(name) || defaultValue);

  const updateState = useCallback(
    (value: string | undefined, days?: number, domain?: string) => {
      setState(value);
      if (value !== undefined) {
        CookieUtils.setCookie(name, value, days, domain);
      } else {
        CookieUtils.eraseCookie(name);
      }
    },
    [name],
  );

  return [state, updateState];
};

export const useCookie = () => {
  return CookieUtils;
};
